import { elements, modifiers } from '#components/generics/js/styles.js'
import { preventClose } from '#utilities/js/lightboxes/lightbox.js'
import { isOpen } from '#utilities/js/lightboxes/seamless.js'
import preventDefault
  from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation
  from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import keyUp from '@mailobj-browser/front/js/events/types/keyUp.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'

const close = element => {
  const { ownerDocument } = element
  const opener = one(`.${elements.sidebar_opener}[aria-expanded="true"]`, ownerDocument)

  element.classList.remove(modifiers.sidebar.open)
  opener.setAttribute('aria-expanded', 'false')
}

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    element, { target }
  ) => {
    if (target.classList.contains(elements.sidebar)) {
      close(element)
    }
  }
})

const onEscape = object(listener, {
  type: keyUp,
  task: (document, event) => {
    const { key } = event
    const sidebarOpen = one(`.${modifiers.sidebar.open}`, document)

    if (key === 'Escape' && sidebarOpen) {
      close(sidebarOpen)
    }
  }
})

export default element => {
  const { ownerDocument } = element

  onClick.listen(element)
  onEscape.listen(ownerDocument)
}
